import './confetti.less';

const NUM_CONFETTI = 350;
const COLORS = [
  [85, 71, 106],
  [174, 61, 99],
  [219, 56, 83],
  [244, 92, 68],
  [248, 182, 70],
];
const PI_2 = 2 * Math.PI;
let xpos = 0.5;
let numberOfVisibleConfettis = 0;

const raf = (() =>
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  ((callback) => window.setTimeout(callback, 1000 / 60)))();

document.addEventListener('onmousemove', (e) => {
  xpos = e.pageX / window.innerWidth;
});

/* eslint-disable */
class Confetti {
  constructor(drawCircle) {
    this.drawCircle = drawCircle;
    this.style = COLORS[~~range(0, 5)];
    this.rgb = "rgba(" + this.style[0] + "," + this.style[1] + "," + this.style[2];
    this.r = ~~range(2, 6);
    this.r2 = 2 * this.r;
    this.replace();
  }

  replace() {
    this.opacity = 0;
    this.dop = 0.03 * range(1, 4);
    this.x = range(-this.r2, window.innerWidth - this.r2);
    this.y = range(-20, window.innerHeight - this.r2);
    this.xmax = window.innerWidth - this.r;
    this.ymax = window.innerHeight - this.r;
    this.vx = range(0, 2) + 8 * xpos - 5;
    return this.vy = 0.7 * this.r + range(-1, 1);
  }

  draw() {
    var ref;
    this.x += this.vx;
    this.y += this.vy;
    this.opacity += this.dop;
    if (this.opacity > 1) {
      this.opacity = 1;
      this.dop *= -1;
    }
    if (this.opacity < 0 || this.y > this.ymax) {
      this.replace();
    }
    if (!((0 < (ref = this.x) && ref < this.xmax))) {
      this.x = (this.x + this.xmax) % this.xmax;
    }
    return this.drawCircle(~~this.x, ~~this.y, this.r, this.rgb + "," + this.opacity + ")");
  }
}
/* eslint-enable */

function range(a, b) {
  return (b - a) * Math.random() + a;
}

export function blow(time = 0) {
  if (numberOfVisibleConfettis >= 3) {
    return;
  }

  const canvas = document.createElement('canvas');
  canvas.className = 'confetti';
  document.body.appendChild(canvas);
  numberOfVisibleConfettis++;

  setTimeout(() => {
    canvas.className = 'confetti enter';
  }, 500);

  const context = canvas.getContext('2d');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  function drawCircle(x, y, r, style) {
    context.beginPath();
    context.arc(x, y, r, 0, PI_2, false);
    context.fillStyle = style;
    return context.fill();
  }

  /* eslint-disable */
  const confetti = (() => {
    var i, j, ref, results;
    results = [];
    for (i = j = 1, ref = NUM_CONFETTI; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
      results.push(new Confetti(drawCircle));
    }
    return results;
  })();

  function step() {
    var c, j, len, results;
    raf(step);
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
    results = [];
    for (j = 0, len = confetti.length; j < len; j++) {
      c = confetti[j];
      results.push(c.draw());
    }
    return results;
  }
  /* eslint-enable */

  step();

  if (time) {
    setTimeout(() => {
      canvas.className = 'confetti leave';
      setTimeout(() => {
        document.body.removeChild(canvas);
        numberOfVisibleConfettis--;
      }, 500);
    }, time);
  }
}
